import { createRoute } from '@tanstack/react-router'
import { rootRoute, requireAuth } from './__root'
import { WebChat } from '../pages/WebChat'

export const chatRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/chat',
  beforeLoad: requireAuth,
  component: WebChat,
})
